import { Direction } from '@/types/direction';
import { Service } from '@/types/service';
import queryString from 'query-string';
import request from '@/lib/request';

type Response = {
  data: Service[];
  meta: any;
};

export default async function getImages(options?: {
  locale: string;
  slug: string;
  baseUrl?: boolean;
}) {
  return await request<Response>(
    'GET',
    `/api/services?${
      options &&
      queryString.stringify({
        locale: options.locale,
        'filters[slug][$eq]': options.slug,
        'populate[images][populate]': 'img',
      })
    }`,
    {
      baseUrl: options?.baseUrl,
      cache: 'no-store',
    }
  );
}
